// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"50459418","242":"fd4ebec4","251":"59c08200","406":"d3952538","766":"78b4f983"}[chunkId] + ".chunk.js";
};